import { ImageService } from "@DavisDigital/services/imageservice";
import { ApiService } from "@DavisDigital/services/apiservice";
import { BaseState } from "@DavisDigital/interfaces/baseState";
import { Modal, PageImage } from "@DavisDigital/interfaces";

type ImageMap = { [key: string]: PageImage };

class ImageGalleryState extends BaseState {
    
    private bookID: string;
    public getBookID = () => this.bookID;
    public setBookID = ( bookID ?: string ) => this.bookID = bookID;
    
    private viewAs : 'single' | 'spread' = 'single' ;
    public getViewAs = () => this.viewAs;
    public setViewAs = ( viewAs ?: 'single' | 'spread' ) => this.viewAs = viewAs;
    
    private initialBookPageNumber : number;
    public getInitialBookPageNumber = () => this.initialBookPageNumber;
    public setInitialBookPageNumber = ( initialBookPageNumber ?: number ) => this.initialBookPageNumber = initialBookPageNumber;
    

    private showNotesFlag = true;
    private showCaptionsFlag = true;
    
    
    public toggleShowNotesFlag  = () => this.showNotesFlag = !this.showNotesFlag;
    public toggleShowCaptionsFlag = () => this.showCaptionsFlag = !this.showCaptionsFlag; 
    
    
    private lastBookPageNumber = 0;
    private images: Array<PageImage> = [];
    public getImages = () => this.images;
    
    public setImageMap = ( imageMap ?: ImageMap ) => {
        this.images = Object.values( imageMap || {} );
        this.images.sort( (a, b) =>  a.page_pageNumber - b.page_pageNumber );
        
        
        this.lastBookPageNumber = Math.max( ...this.images.map( img => img.page_pageNumber ) );
    }
    
    private prevImage: PageImage;
    private nextImage: PageImage;
    private currentImage: PageImage;
    private currentImageNumber = 1;
    private currentBookPageNumber = 1;
    
    public getCurrentImage = () => this.currentImage;
    public getCurrentImageNumber = () => this.currentImageNumber;
    public getCurrentBookPageNumber = () => this.currentBookPageNumber;
    
    private lastImageReached = false;
    private firstImageReached = true;
    
    
    private setCurrentImageByIndex = (index: number) => {
        
        this.currentImage = this.images[ index ];
        this.currentBookPageNumber = this.currentImage.page_pageNumber;
        
        this.prevImage = ( index == 0 )                     ? null : this.images[ index - 1 ];
        this.nextImage = ( index == this.images.length-1 )  ? null : this.images[ index + 1 ];
        
        this.firstImageReached = false;
        this.lastImageReached = false;
        
        if( index == (this.images.length - 1) ){
            
            this.lastImageReached = true;

        } else if( index == 0 ){
            
            this.firstImageReached = true;
        }
        
        this.currentImageNumber = index + 1;
    }
    
    public loadPageImage = (pageNumber: number) => {
        
        if( this.lastImageReached ){
            return console.error(`Last image reached, can't load image for page: ${pageNumber}`);
        }
        
        if( pageNumber > this.lastBookPageNumber){
            console.warn(`Page-number: ${pageNumber} is greater then last book page with images: ${this.lastBookPageNumber} falling-back`);
            return this.loadPageImage( this.lastBookPageNumber );
        }
        
        let pageImageIndex = this.images.findIndex( (image) => image.page_pageNumber == pageNumber );
        
        if(  pageImageIndex > -1 ){
            
            this.setCurrentImageByIndex(pageImageIndex);
            
        } else if( pageNumber < this.lastBookPageNumber ){
            
            //if there're no images for the current page, try finding for the next
            this.loadPageImage( pageNumber+1 );
        } 
        else {
            console.error("last page reached, no image found");    
        }
    }
    
    public loadNextImage = () => {
        
        if( !this.images.length ){
            return console.error("no images"); ;
        }
        
        if(this.lastImageReached){
           return console.error("last image reached"); 
        }
        
        let index = this.images.indexOf(this.currentImage);
        index += 1; // so that it points to the next image;
        
        this.setCurrentImageByIndex(index);
    }
    
    public loadPreviousImage = () => {
        
        if( !this.images.length ){
            return console.error("no images"); ;
        }
        
        if(this.firstImageReached){
           return console.error("first image reached"); 
        }
        
        let index = this.images.indexOf(this.currentImage);
        index -= 1; // so that it points to the next image;
        
        this.setCurrentImageByIndex(index);
    }

}


export class ImageGalleryController {
    
    public state$: ImageGalleryState;
    
    // @ngInject
	constructor(
		private $attrs:	    	ng.IAttributes,
		private $window:		ng.IWindowService,
		private $timeout:		ng.ITimeoutService,
		private $location:		ng.ILocationService,
		private apiService: 	ApiService,
		private imageService:	ImageService,
		private ModalService,
	){
	    this.state$ = new ImageGalleryState();
	}
	
	public $onInit = () => {
	    this.state$.setBookID( this.$attrs?.bookId);
	    this.state$.setViewAs(this.$attrs?.viewAs);
        this.state$.setInitialBookPageNumber( Number.parseInt(this.$attrs?.pageNumber) || 1  );
	    
	    this.fetchPagesImages().then( () => {
            //scroll to the current page
            this.state$.loadPageImage( this.state$.getInitialBookPageNumber() );
	    });
	}
	
	//UI enent-handlers
	public onTogglShowNotes = () => {
	    this.state$.toggleShowNotesFlag();
	    $('.gallery-bar .gallery .gallery-slider .repeat .slide-content').toggleClass('hide-note');
	}
	
	public onTogglShowCaptions = () => {
	    this.state$.toggleShowCaptionsFlag();
	}
	
	public onAddEditNote = () => {
	    this.launchAddEditPageImageNoteModal( angular.copy( this.state$.getCurrentImage() ) );
	}
	
	public onDeleteNote = () => {
	    this.launchConfirmDeletePageImageNoteModal( this.state$.getCurrentImage() );
	}
	
	public onNextImage = () => {
	    this.state$.loadNextImage();
	}
	
	public onPreviousImage = () => {
	    this.state$.loadPreviousImage()
	}
	
	
	public onLaunchSlideShow = () => {

        let images = this.state$.getImages().map( (img) => {
        	let isPageImageNote=null;
        	
        	if(img.hasOwnProperty('pageImageNote'))
        	{
        		isPageImageNote=img.pageImageNote.note;
        		
        	}
        	
        	
	        return {
	        	s3PathToImageFile : img.image_s3PathToImageFile,
	        	imageMetaData : img.image_imageMetaData,
	        	pageImageNote:isPageImageNote,
	        	
	        }
	    })
	    
	    this.launchSlideshowModal(  images, this.state$.getCurrentImageNumber() - 1 );
	}
	
	
	
	//internal functions
	
	private fetchPagesImages = () => {
	    return this.imageService
	    
	    .getPageImagesForBook( this.state$.getBookID() )
	
	    .then( ( data: any ) => {
	        this.state$.setImageMap( data.pageImageMap );
	    })
	    .catch(console.error);
	}
	
	
	private launchSlideshowModal = ( images: Array<any>, goTo = 0) => {
		let bindings:any = {
			images: images,
			goTo : goTo
		}
		
		this.ModalService.showModal({
			component: 'imageGallerySlideshowModal',
			bodyClass: 'angular-modal-service-active',
			bindings: bindings,
			preClose: this.ModalService.closeModals,
		})
		.then( (modal: Modal) =>  modal.close.then( (result) => {}) );
	}
	
	private launchAddEditPageImageNoteModal = ( pageImage: PageImage ) => {
		
		let bindings:any = {
			pageImage: pageImage
		}
		
		this.ModalService.showModal({
			component: 'addEditPageImageNoteModal',
			bodyClass: 'angular-modal-service-active',
			bindings: bindings,
			preClose: this.ModalService.closeModals,
		})
		.then((modal: Modal) =>  modal.close.then( (pageImage: PageImage) => {
		    //save updated page-image
		    console.log("updated page-image/note", pageImage);
		}));
	}
	
	private launchConfirmDeletePageImageNoteModal = ( pageImage: PageImage ) => {
		
		let bindings:any = {
			heading: "Confirm",
    	    message: "Are you sure you want to delete this Note?",
    	    confirmButtonText: "Delete"
		}
		
		this.ModalService.showModal({
			component: 'confirmActionModal',
			bodyClass: 'angular-modal-service-active',
			bindings: bindings,
			preClose: this.ModalService.closeModals,
		})
		.then( (modal: Modal) =>  modal.close.then( (confirm) => {
		    
		    if( confirm ){
		        this.imageService.deleteNote( this.state$.getCurrentImage().pageImageNote.pageImageNoteID )
		            .then( () =>  this.state$.getCurrentImage().pageImageNote = null )
		            .catch( console.error );
		    }
		}));
	}

    
}
